import React from 'react';
import { Motion, spring } from 'react-motion';
import { Icon } from 'b3';

export default function WizardCompletedSuccess() {
	return (
		<div id="wizard-completed-success">
			<Motion defaultStyle={{scale: 0.6}} style={{scale: spring(1, {stiffness: 150, damping: 8})}}>			
			{({scale}) =>
				<div className="like-wrapper" style={{transform: `scale(${scale})`}}>
					<Icon icon="hand-like-2" size={70} />
				</div>
			}
			</Motion>
			<h1>All saved, nice work!</h1>
		</div>
	);
}




// WEBPACK FOOTER //
// ./app/components/schedule-wizard/WizardCompletedSuccess.js